import React from 'react';

const SocialMedia = () => {
  const styles = {
    badgeRow: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 10,
      alignItems: 'center',
      marginTop: 6,
      marginBottom: 16,
      padding: '10px 12px',
      borderRadius: 12,
      border: '1px solid #e5e7eb',
      background: '#f9fafb',
      fontSize: 13.5,
      color: '#111827',
      lineHeight: 1.4,
    },
    badgeDot: { color: '#9ca3af' },

    p: {
      fontSize: 14.5,
      lineHeight: 1.75,
      margin: '10px 0',
      color: '#111827',
    },

    h2: {
      fontSize: 18,
      margin: '26px 0 10px',
      fontWeight: 900,
      letterSpacing: '-0.01em',
      color: '#111827',
    },

    // Section heading inside the role content
    h3: {
      margin: '18px 0 8px',
      fontSize: 15,
      fontWeight: 900,
      letterSpacing: '-0.01em',
      color: '#111827',
    },

    ul: {
      margin: '10px 0 10px 22px',
      fontSize: 14.5,
      lineHeight: 1.75,
      color: '#111827',
    },

    highlightBox: {
      marginTop: 18,
      padding: 14,
      borderRadius: 12,
      border: '1px solid #dbeafe',
      background: '#eff6ff',
      lineHeight: 1.6,
    },
    highlightText: {
      margin: 0,
      fontSize: 14.5,
      color: '#111827',
    },
  };

  return (
    <div>
      <h2 style={styles.h2}>Social Media &amp; Content Manager</h2>

      <div style={styles.badgeRow}>
        <span>
          📍 <strong>Remote / Hybrid</strong>
        </span>
        <span style={styles.badgeDot}>•</span>
        <span>
          🚀 <strong>Startup Role</strong>
        </span>
        <span style={styles.badgeDot}>•</span>
        <span>
          🍔 <strong>Food-Delivery App</strong>
        </span>
      </div>

      <p style={styles.p}>
        We’re looking for a creative, hands-on Social Media &amp; Content Manager to help shape our
        brand voice and grow our presence across social platforms.
      </p>

      <p style={styles.p}>
        This role is ideal for someone who loves storytelling, creating engaging content, and
        turning ideas into eye-catching posts, ads, and visuals.
      </p>

      <h3 style={styles.h3}>What You’ll Do</h3>
      <ul style={styles.ul}>
        <li>Manage and grow our social media accounts (Instagram, Facebook, LinkedIn, etc.)</li>
        <li>Create engaging content: posts, stories, reels, short videos, and graphics</li>
        <li>Design creative ads and promotional content for campaigns</li>
        <li>Develop content calendars and posting schedules</li>
        <li>Collaborate with founders on brand messaging and campaigns</li>
        <li>Monitor performance and suggest improvements</li>
      </ul>

      <h3 style={styles.h3}>What We’re Looking For</h3>
      <ul style={styles.ul}>
        <li>Strong creativity and visual sense</li>
        <li>Experience with social media management and content creation</li>
        <li>Comfortable designing ads, graphics, or short videos</li>
        <li>Good communication and storytelling skills</li>
        <li>Self-motivated and comfortable working in a startup environment</li>
        <li>Experience with tools like Canva, Adobe, Figma, or similar is a plus</li>
      </ul>

      <h3 style={styles.h3}>Why Join Us</h3>
      <ul style={styles.ul}>
        <li>Be part of a growing startup where your ideas matter</li>
        <li>Creative freedom and ownership of brand voice</li>
        <li>Work closely with founders and leadership</li>
        <li>Flexible work environment</li>
        <li>Opportunity to grow with the company</li>
      </ul>

      <div style={styles.highlightBox}>
        <p style={styles.highlightText}>
          If you’re creative, passionate about social media, and excited to build a brand from the
          ground up, <strong>we’d love to hear from you!</strong>
        </p>
      </div>

      <div
        style={{
          marginTop: 16,
          padding: 16,
          borderRadius: 14,
          border: '2px solid #FF6138',
          background: '#fff2ecff',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 12,
          }}
        >
          <div style={{ minWidth: 220 }}>
            <div
              style={{
                fontSize: 14.5,
                fontWeight: 900,
                color: '#111827',
                letterSpacing: '-0.01em',
              }}
            >
              Apply by Email
            </div>
            <div style={{ marginTop: 6, fontSize: 13.5, color: '#374151', lineHeight: 1.6 }}>
              Email your <strong>CV/Resume</strong> and mention the <strong>Job Title</strong> in
              the subject line.
            </div>
          </div>

          <a
            href='mailto:jobs@singlecombo.com?subject=Application%20-%20Social%20Media%20%26%20Content%20Manager'
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 8,
              padding: '10px 12px',
              borderRadius: 12,
              border: '1px solid #dbeafe',
              background: '#eff6ff',
              color: '#111827',
              textDecoration: 'none',
              fontSize: 13.5,
              fontWeight: 800,
              whiteSpace: 'nowrap',
            }}
            aria-label='Email jobs@singlecombo.com'
          >
            ✉️ jobs@singlecombo.com
          </a>
        </div>

        <div
          style={{
            marginTop: 12,
            paddingTop: 12,
            borderTop: '1px solid #e5e7eb',
            display: 'grid',
            gap: 8,
          }}
        >
          <div style={{ fontSize: 13, color: '#6b7280' }}>
            <strong style={{ color: '#111827' }}>Subject:</strong> Application - Social Media &
            Content Manager
          </div>
          <div style={{ fontSize: 13, color: '#6b7280', lineHeight: 1.6 }}>
            <strong style={{ color: '#111827' }}>Include:</strong> Name • Location • Portfolio /
            Social handles • Tools used (Canva, Adobe, Figma) • Availability
          </div>
        </div>
      </div>
    </div>
  );
};

export default SocialMedia;
